import { Box, Typography } from "@mui/material";
import CartoonishDivider from "components/CartoonishDivider";

function SectionDivider({ title, subtitle, withDivider = false, sx }) {
  return (
    <Box py={10}>
      {withDivider && <CartoonishDivider />}
      <Typography
        variant="h1"
        align="center"
        color="white !important"
        sx={{
          textShadow: "4px 4px 0px black",
          mt: 10,
          mb: subtitle ? 1 : 5,
          ...sx,
        }}
      >
        {title}
      </Typography>

      {subtitle && (
        <Typography
          variant="h5"
          align="center"
          color="white !important"
          sx={{
            fontStyle: "italic",
            textShadow: "2px 2px 0px rgba(0,0,0,0.5)",
            mb: 5,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}

export default SectionDivider;
